import { useCallback, useContext, useState } from 'react'
import { ToastContext } from '@/components/Toast/Toast'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { useFetchOne } from 'utils/api/useFetch'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

import {
  TransactionDetailsBonusGeneralForm,
  TransactionDetailsBonusGeneralProps,
} from './TransactionDetailsBonusGeneralForm'

export const TransactionDetailsBonusGeneralPage: React.FC<TransactionDetailsBonusGeneralProps> = (
  props
) => {
  const { setAuditLogModal, onSubmit, setActiveTab } = props
  const { transaction, client, permissions, bonusStatuses, bonusTypes, bonusLabels } = props

  const [isEdit, setEdit] = useState(false)

  const walletsApiClient = useApiClient(WalletsApiClient)

  const callback = useCallback(
    async () => await walletsApiClient.getTransactionNotesByTransactionId(props.transaction.id),
    [props.transaction.id]
  ) // eslint-disable-line react-hooks/exhaustive-deps

  const { data: notes, isLoading } = useFetchOne(callback)

  return (
    <Loading isLoading={isLoading}>
      {notes && (
        <TransactionDetailsBonusGeneralForm
          transaction={transaction}
          notes={notes}
          client={client}
          permissions={permissions}
          bonusTypes={bonusTypes}
          bonusStatuses={bonusStatuses}
          onSubmit={onSubmit}
          setAuditLogModal={setAuditLogModal}
          setActiveTab={setActiveTab}
          isEdit={isEdit}
          setEdit={setEdit}
          bonusLabels={bonusLabels}
          setToast={useContext(ToastContext)}
        />
      )}
    </Loading>
  )
}
